<nz-radio-group [name]="config.name" [(ngModel)]="config.value" (ngModelChange)="onChange($event)" [required]="config.required">
  <ng-container *ngFor="let item of config.dataSource">
    <label nz-radio [nzValue]="item.value">{{ item.label }}</label>
  </ng-container>
</nz-radio-group>
